export default __webpack_public_path__ + "static/media/640_portfolio02-jp-mobile.54b800fa.png";